/** Bounds shared with the editor speed field. */
export const MIN_MEDIA_PLAYBACK_RATE = 0.25;
export const MAX_MEDIA_PLAYBACK_RATE = 2;

/** Valid Remotion playbackRate, or undefined to omit (rate 1). */
export function mediaPlaybackRate(rate: unknown): number | undefined {
  if (typeof rate !== "number" || !Number.isFinite(rate) || rate <= 0) {
    return undefined;
  }
  return Math.min(
    MAX_MEDIA_PLAYBACK_RATE,
    Math.max(MIN_MEDIA_PLAYBACK_RATE, rate),
  );
}

/** Pitch preservation for sped audio/video. Omitted or any non-false value is on. */
export function mediaPreservePitch(value: unknown): boolean {
  return value !== false;
}

/** SSR pitch for OffthreadVideo / Html5Audio. Omitted when preserve is on (ffmpeg atempo). Equals rate when off. */
export function mediaExportToneFrequency(
  playbackRate: number | undefined,
  preservePitch: boolean,
): number | undefined {
  if (playbackRate == null || playbackRate === 1 || preservePitch) {
    return undefined;
  }
  return playbackRate;
}

/**
 * Preview backend for `@ad-studio/audio`.
 * `@remotion/media` Audio shares a clock with video but pitch-shifts with playbackRate: Mediabunny / WebCodecs cannot time-stretch.
 * Html5Audio + preservePitch (and Lambda ffmpeg atempo) preserve pitch.
 * https://www.remotion.dev/docs/media/audio
 */
export function audioPreviewComponent(
  playbackRate: number | undefined,
  preservePitch: boolean = true,
): "html5" | "mediabunny" {
  const sped = playbackRate != null && playbackRate !== 1;
  return sped && preservePitch ? "html5" : "mediabunny";
}
